var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"part-info"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('span',[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }